export default {
  setpointEnter: 'Setpoint enter',
  durationMinusLimit: 'Duration - limit',
  realDuration: 'Real duration',
  durationPlusLimit: 'Duration + limit',
  totalTime: 'Total in band time',
};
